export const name = "RANGE_START";
export const summary = `Gets the lower bound of a range.`;
export const reference = `
## RANGE_START

Gets the lower bound of a range.

\`\`\`
RANGE_START(range_to_check)
\`\`\`

### Description

Gets the lower bound of a range.


### Definitions

- \`range_to_check\`: The \`RANGE<T>\` value.


### Details

Returns \`NULL\` if the lower bound of \`range_value\` is \`UNBOUNDED\`.

Returns \`NULL\` if \`range_to_check\` is \`NULL\`.


### Return type

\`T\` in \`range_value\`


### Examples

In the following query, the lower bound of the range is retrieved:



\`\`\`
SELECT RANGE_START(RANGE<DATE> '[2022-12-01, 2022-12-31)') AS results;

/*------------+
 | results |
 +------------+
 | 2022-12-01 |
 +------------*/
\`\`\`

In the following query, the lower bound of the range is unbounded, so\`NULL\` is returned:



\`\`\`
SELECT RANGE_START(RANGE<DATE> '[UNBOUNDED, 2022-12-31)') AS results;

/*------------+
 | results |
 +------------+
 | NULL |
 +------------*/
\`\`\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/range-functions
`;
